import React from 'react';
import {createRoot} from 'react-dom/client';
import {useSHCore} from '@hooks/useSHCore';
import {getInitialMeta, getInitialPageState} from "@helpers/HelperInitialPageState";
import {ContextServicePriceProvider} from "@contexts/ContextServicePriceProvider";
import {ContextTLDProvider} from "@contexts/ContextTLDProvider";
import {ContextNotificationProvider} from "@contexts/ContextNotificationProvider";
import {ContextCartProvider} from "@contexts/ContextCartProvider";
import styles from './PageHome.scss';
import Header from '@components/base/Header/Header';
import Footer from '@components/base/Footer/Footer';
import HomePageHeaderData from '@components/base/Header/data/HomePageHeaderData';
import ContentA1 from "@components/blocks/ContentA1/ContentA1";
import SuperTeamHomeData from "@components/blocks/ContentA1/data/SuperTeamHomeData";
import SuperSpeedHomeData from "@components/blocks/ContentA1/data/SuperSpeedHomeData";
import FreeMigrationData from "@components/blocks/ContentA1/data/FreeMigrationData";
import SomeThingBiggerData from "@components/blocks/ContentA1/data/SomeThingBiggerData";
import ContentA2 from "@components/blocks/ContentA2/ContentA2";
import SuperSecurityHomeData from "@components/blocks/ContentA2/data/SuperSecurityHomeData";
import ContentB2 from "@components/blocks/ContentB2/ContentB2";
import OurClientsData from "@components/blocks/ContentB2/data/OurClientsData";
import ContentD4 from "@components/blocks/ContentD4/ContentD4";
import NewProductsBannersData from "@components/blocks/ContentD4/data/NewProductsBannersData";
import ScaleBusinessBannersData from "@components/blocks/ContentD4/data/ScaleBusinessBannersData";
import SaaSBannersData from "@components/blocks/ContentD4/data/SaaSBannersData";
import ContentD1 from "@components/blocks/ContentD1/ContentD1";
import OurClientsVideoData from "@components/blocks/ContentD1/data/OurClientsVideoData";
import ContentF1 from "@components/blocks/ContentF1/ContentF1";
import SelectedFromTheBlogData from "@components/blocks/ContentF1/data/SelectedFromTheBlogData";
import MenuBottom from "@components/base/MenuBottom/MenuBottom";

const PageHome = (props) => {
	useSHCore({props, name: 'PageHome', isPage: true});

	return (
	  <>
		  <ContextCartProvider>
			  <ContextServicePriceProvider>
				  <ContextTLDProvider>
					  <ContextNotificationProvider color={'color-brand-orange-400'}>
						  <Header data={HomePageHeaderData}/>

						  <main>
							  <ContentD4 data={NewProductsBannersData}/>
							  <ContentD4 data={ScaleBusinessBannersData}/>
							  <ContentD4 data={SaaSBannersData}/>
							  <ContentA1 data={SuperTeamHomeData} color={'color-brand-orange-400'}/>
							  <ContentA1 data={SuperSpeedHomeData} color={'color-brand-orange-400'}/>
							  <ContentF1 data={SelectedFromTheBlogData} color={'color-brand-orange-400'}/>
							  <ContentA2 data={SuperSecurityHomeData} columns={3} color={'color-brand-orange-400'}/>
							  <ContentA1 data={FreeMigrationData} color={'color-brand-orange-400'}/>
							  <ContentD1
								data={OurClientsVideoData}
								color={'color-brand-orange-400'}
								blockSize={'800'}
								videoSize={'360'}
							  />
							  <ContentB2 data={OurClientsData} color={'color-brand-orange-400'}/>
							  <ContentA1 data={SomeThingBiggerData} color={'color-brand-orange-400'}/>

							  <MenuBottom color={'color-brand-orange-400'}/>
						  </main>

						  <Footer color={'color-brand-orange-400'}/>
					  </ContextNotificationProvider>
				  </ContextTLDProvider>
			  </ContextServicePriceProvider>
		  </ContextCartProvider>
	  </>
	)
};

const container = document.getElementById(getInitialMeta('pageAppId'));
const root = createRoot(container);
root.render(<PageHome data={getInitialPageState()}/>);
